import Vue from 'vue'

import router from './router'
import App from './App.vue'
import 'lib-flexible'
import axios from 'axios'
import './font/iconfont.css'

Vue.prototype.$axios = axios
Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    group_id: '',
    group_name: '选择分组',
    only_online: false,
    time_reverse: false,
    show_id: false,
    show_simple: false,
    is_xcx: false,
    is_login: false,
    openid: ''
  },
  mutations: {
    set_gid(state, gdata) {
      state.group_id = gdata.gid;
      state.group_name = gdata.gname;
    },
    set_only_online(state, only_online) {
      state.only_online = only_online;
    },
    set_time_reverse(state, time_reverse) {
      state.time_reverse = time_reverse;
    },
    set_show_id(state, show_id) {
      state.show_id = show_id;
    },
    set_show_simple(state, show_simple) {
      state.show_simple = show_simple;
    },
    set_is_xcx(state, is_xcx) {
      state.is_xcx = is_xcx;
    },
    set_is_login(state, is_login) {
      state.is_login = is_login;
    },
    set_openid(state, openid) {
      state.openid = openid;
    }
  }
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')